/* eslint-disable no-unused-vars */
export enum ContentDisplayModes {
  CONTACT_DETAILS_AND_IMAGE = 'image-and-contact-details',
  IMAGE_TEXT = 'image-text',
  IMAGE_LIST = 'image-list',
  TEXT_LIST = 'text-list',
  IMAGE_AND_FORM = 'image-and-form',
}
